import './index.scss';

export interface IBreadcrumbItem {
    url: string | undefined;
    label: string | undefined;
}

interface IBreadcrumbParams {
    items: Array<IBreadcrumbItem>;
}

const Breadcrumbs = (params: IBreadcrumbParams) => {
    return (
        <div className="breadcrumbs">
            {params.items.map((item: IBreadcrumbItem, index: number) => (
                <a className={params.items.length > 1 ? 'hide-dashboard' : ''} key={index} href={item.url}><span>{item.label}</span></a>
            ))
            }
        </div >
    )
}

export default Breadcrumbs;